import React from "react";
import SvgIcon from "@mui/material/SvgIcon";
import IconPaths from "./IconPaths";
import { useTheme } from "@mui/material";

export type TToggleIconProps = {
  name: string;
  color?: string;
  onClick?: React.MouseEventHandler<SVGSVGElement> | undefined;
};

const ToggleIcon = (props: TToggleIconProps) => {
  const { name, color, onClick, ...rest } = props;
  const { palette } = useTheme();
  return (
    <SvgIcon
      htmlColor={color || palette.primary.text}
      onClick={onClick}
      {...rest}
    >
      <path d={IconPaths[name]} fill="inherit" />
    </SvgIcon>
  );
};

export default ToggleIcon;
